module.exports = __webpack_public_path__ + "static/img/家具.56b0f40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/家具.jpg
// module id = 3sp4
// module chunks = 1